import Cookies from 'js-cookie';

// The sysbay service replies to every session-authed request by setting HttpOnly cookies named
// bayToken, currentSessionToken, and sessionToken on this same origin (see the service's auth
// plugin). A JS-readable cookie by any of those names gets clobbered by that HttpOnly cookie on
// the very next response, so the UI's own copy of the session token has to live under a
// different name.
const KEY = 'toolboxToken';

export const getToken = (): string | undefined => Cookies.get(KEY);
export const setToken = (token: string) => Cookies.set(KEY, token);
export const clearToken = (): void => Cookies.remove(KEY);

let signingOut = false;

/**
 * The one auth redirect: drop the session and return to sign-in. Called by the 401 response
 * interceptor and by the session-expiry prompts, and idempotent, so a burst of 401s or a
 * double click leaves one navigation.
 */
export const signOut = (): void => {
  if (signingOut) return;
  signingOut = true;
  sessionStorage.clear();
  clearToken();
  window.location.href = '/';
};
